"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _positions = _interopRequireDefault(require("./positions.js"));
var _getoffset = require("getoffset");
// @ts-check

/**
 * @param {OffsetType} domInfo 
 * @param {string} loc 
 * @returns {[number, number]}
 */
var getAlignTargetXY = function getAlignTargetXY(domInfo, loc) {
  var xy;
  var width = domInfo.right - domInfo.left;
  var height = domInfo.bottom - domInfo.top;
  switch (loc) {
    case _positions["default"].TL:
    case _positions["default"].LT:
      xy = [domInfo.left, domInfo.top];
      break;
    case _positions["default"].TC:
      xy = [domInfo.left + Math.floor(width / 2), domInfo.top];
      break;
    case _positions["default"].TR:
    case _positions["default"].RT:
      xy = [domInfo.right, domInfo.top];
      break;
    case _positions["default"].RC:
      xy = [domInfo.right, domInfo.top + Math.floor(height / 2)];
      break;
    case _positions["default"].RB:
    case _positions["default"].BR:
      xy = [domInfo.right, domInfo.bottom];
      break;
    case _positions["default"].BL:
    case _positions["default"].LB:
      xy = [domInfo.left, domInfo.bottom];
      break;
    case _positions["default"].BC:
      xy = [domInfo.left + Math.floor(width / 2), domInfo.bottom];
      break;
    case _positions["default"].LC:
      xy = [domInfo.left, domInfo.top + Math.floor(height / 2)];
      break;
    case _positions["default"].CC:
      xy = [domInfo.left + Math.floor(width / 2), domInfo.top + Math.floor(height / 2)];
      break;
    default:
      console.error("Not support align type. [" + loc + "]");
      break;
  }
  return /** @type [number, number]*/xy;
};
var _default = exports["default"] = getAlignTargetXY;
module.exports = exports.default;